import { GivelifyButton, GivelifyLabel } from '@givelify/givelify-ui';
import { GivelifyLegacyColorPalette } from '@givelify/ui';
import { Box, Card, FormControlLabel, Grid, styled } from '@mui/material';
import OnEnterChangeTextField from 'components/inputs/OnEnterChangeTextField';

export const CardName = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

export const IntegrationCard = styled(Card)(({ theme }) => ({
    borderRadius: 11,
    minWidth: 248,
    margin: theme.spacing(0, 2, 3, 0),
    '&:nth-child(4n)': {
        marginRight: 0,
        [theme.breakpoints.down('md')]: {
            marginRight: theme.spacing(2),
        },
    },
}));

export const Frequency = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
}));

export const FrequencyText = styled(GivelifyLabel)({
    display: 'inline',
});

export const IntegrationContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

export const ListThirdParty = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    '& .integration-name': {
        marginTop: theme.spacing(3),
    },
}));

export const OpenThirdPartyButton = styled(GivelifyLabel)(({ theme }) => ({
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    textDecoration: 'underline',
    cursor: 'pointer',
}));

export const NumberCount = styled('span')({
    top: 3,
    right: '-33px',
    position: 'absolute',
    background: '#FF1612',
    fontSize: 14,
    padding: '1px 5px',
    borderRadius: '25px',
    color: '#fff',
    lineHeight: '16px',
});

export const StyledThirdPartyModal = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 7, 5),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0, 3),
    },
}));

export const ThirdParty = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
});

export const ThirdPartyInfo = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(3),
}));

export const DonorNameContent = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});

export const EmailContent = styled(GivelifyLabel)({
    width: '100%',
    wordWrap: 'break-word',
});

export const EnvelopeName = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(0, 2),
    alignSelf: 'stretch',
    borderRight: '1px solid #cacaca',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2),
    },
}));

export const HeaderItemRight = styled(GivelifyLabel)({
    lineHeight: '20px',
});

export const IntegrationInput = styled(OnEnterChangeTextField)(({ theme }) => ({
    '& .MuiInputBase-input': {
        height: 48,
        padding: theme.spacing(3),
        boxSizing: 'border-box',
        width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
        maxWidth: 'none',
    },
    [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0, 0, 2),
        borderLeft: 0,
    },
}));

export const IntegrationInputRight = styled(Grid)(({ theme }) => ({
    position: 'relative',
    paddingLeft: theme.spacing(2),
    '& .MuiTextField-root': {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 3, 2, 0),
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
        },
    },
}));

export const LabelWrapper = styled(Box)({
    minHeight: 64,
    display: 'flex',
    alignItems: 'center',
});

export const MatchButton = styled(GivelifyButton)({
    '& span': { textAlign: 'left' },
});

export const MatchHeader = styled(Grid)({
    height: '54px',
    borderBottom: '1px solid #cacaca',
    fontWeight: 700,
    flexWrap: 'nowrap',
    alignItems: 'center',
    '& $matchHeaderItem': {
        borderBottom: 'none',
    },
});

export const MatchHeaderItem = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(0, 0, 0, 2),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: 14,
    fontWeight: 800,
    height: '100%',
    borderBottom: '1px solid ' + GivelifyLegacyColorPalette.neutralPlatinum,
}));

export const MatchItem = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRight: '1px solid #e3e3e3',
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 3),
        borderBottom: '1px solid #e3e3e3',
    },
}));

export const LastMatchItem = styled(MatchItem)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        borderBottom: '0',
    },
    [theme.breakpoints.down('xs')]: {
        borderBottom: '1px solid #e3e3e3',
    },
}));

export const MatchRowContent = styled(Grid)(({ theme }) => ({
    flexWrap: 'nowrap',
    borderBottom: '1px solid #cacaca',
    minHeight: 64,
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
    },
}));

export const MatchingButtonContent = styled(Grid)(({ theme }) => ({
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        marginTop: theme.spacing(1),
    },
}));

export const MatchingSuccess = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const MatchingFooter = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2, 4),
}));

export const SuccessImage = styled('img')(({ theme }) => ({
    marginRight: theme.spacing(1),
}));

export const TypeItem = styled(FormControlLabel)(({ theme }) => ({
    marginLeft: 0,
    '& .MuiButtonBase-root': {
        display: 'none',
    },
    '& .MuiFormControlLabel-label': {
        border: '1px solid transparent',
        borderRadius: 10,
        padding: theme.spacing(2, 4),
        boxShadow: '0px 0px 8px rgba(152, 162, 173, 0.4)',
        fontSize: 18,
        lineHeight: '22px',
        fontWeight: 700,
        [theme.breakpoints.down('md')]: {
            paddingLeft: '12px',
            paddingRight: '12px',
        },
    },
    '& .Mui-checked + .MuiFormControlLabel-label': {
        border: '1px solid ' + theme.legacy.palette.primary.main,
    },
    '&:last-child': {
        marginRight: 0,
    },
}));

export const SelectIntegrationContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const SelectTypeContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(1),
}));
